$( document ).ready(function() {
    console.log( "ready!" );
    $( ".newsletter-form2" ).submit(function( event ) {
      event.preventDefault();
      var email = $('.email-field').val();
      if( !validateEmail(email)) {
          alert("Please add valid email");
          return false;
      }
      $('.news-field').hide();
      $('.newsletter-form__message').show();
      
      $.ajax({
        type: "POST",
        url: "/account",
        data: {
          "customer[email]": email,
          "customer[password]":"helloworld@1"
        },
      });
    });
});
$('.custom-register-popup').click(function() {
   
   $('.newsletter-form__message').hide();
   $('#popup-newsltter').show();
});
if(sessionStorage["PopupShown"] != 'yes'){ 
  setTimeout(function() {
      $('.newsletter-form__message').hide();
      $('#popup-newsltter').show();
      sessionStorage["PopupShown"] = 'yes';
  }, 5000);
}
$("#popupclose-icon").click(function(){
  $("#popup-newsltter").hide();
});
function validateEmail($email) {
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  return emailReg.test( $email );
}

function addComparePrice() {
  const prices = document.querySelectorAll(".style_price_fac40ac3");

  prices.forEach((priceBox) => {
    if (!priceBox.querySelector(".compare-price")) {
      const compare = document.createElement("div");
      compare.className = "compare-price";
      compare.innerHTML = '<span style="font-size: 13px;color:#004a7c;">( MRP <span style="text-decoration:line-through;">Rs. 750.00 )</span></span>';
      priceBox.appendChild(compare);
    }
  });
}

// run every 500ms until element appears
setInterval(addComparePrice, 500);